module.exports = __webpack_public_path__ + "static/img/logo_idtroc.10f1832.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SVG/logo_idtroc.svg
// module id = 5wjy
// module chunks = 1